/**
 * Sheet & Modal Tokens
 */

import { bg, text, accent, corners, space, animation, platform } from "../semantic";

export const sheet = {
  bg: platform.pageBg,
  radius: corners.sheet,
  padding: space.pagePadding,
  backdrop: bg.overlay,
  backdropBlur: "4px",
  handle: { width: "36px", height: "4px", radius: "2px", bg: text.muted, opacity: 0.3 },
  animation: animation.sheet,
} as const;

export const deleteSheet = {
  icon: { size: "56px", radius: corners.card, bg: accent.dangerMuted, color: accent.danger, iconSize: "28px" },
  title: { fontSize: "20px", fontWeight: "700", color: text.primary },
  message: { fontSize: "15px", color: text.muted },
  buttonGap: space.insetMd,
} as const;
